module.exports = __webpack_public_path__ + "img/rules.b8a7d3f7.svg";